import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { Store } from '@ngrx/store';
import { UserState } from '../store/user/user.reducer';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';
import { UserRoles } from '../components/login/user.model';

export const blockViewerGuard: CanActivateFn = (route, state) => {
  const store = inject(Store<{ user: UserState }>);

  return store.select('user').pipe(
    map((res) => {
      if (!res.user) {
        return false;
      }

      if (res.user.role === UserRoles.Viewer) {
        return false;
      }
      return true;
    })
  );
};
